/* Busca inteligente NutriCaps
 * - Sugestões de produtos enquanto o cliente digita (a partir de 2 letras)
 * - Acha por pedaço da palavra ("amo" → Amora) em TODAS as barras de busca
 * - Busca vazia → mostra todos os produtos
 */
(function () {
  'use strict';

  var css = '' +
    '.psr-host{position:relative;}' +
    '.psr{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:60;background:#fff;border:1px solid hsl(var(--border));border-radius:14px;box-shadow:0 12px 32px rgba(0,0,0,.14);overflow:hidden;text-align:left;}' +
    '.psr[hidden]{display:none;}' +
    '.psr__list{list-style:none;margin:0;padding:.25rem 0;max-height:min(60vh,420px);overflow-y:auto;}' +
    '.psr__item a{display:grid;grid-template-columns:48px 1fr;gap:.75rem;align-items:center;padding:.5rem .875rem;text-decoration:none;color:hsl(var(--foreground));}' +
    '.psr__item a:hover,.psr__item.is-active a{background:hsl(var(--secondary) / .6);}' +
    '.psr__img{width:48px;height:48px;border-radius:8px;object-fit:cover;background:hsl(var(--secondary));display:block;}' +
    '.psr__title{font-size:.875rem;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}' +
    '.psr__title mark{background:none;color:hsl(var(--primary));font-weight:800;}' +
    '.psr__price{font-size:.8125rem;font-weight:700;color:hsl(var(--primary));margin-top:.125rem;}' +
    '.psr__empty{padding:1rem .875rem;font-size:.875rem;color:hsl(var(--muted-foreground));}' +
    '.psr__all{display:block;padding:.75rem .875rem;border-top:1px solid hsl(var(--border));font-size:.875rem;font-weight:700;color:hsl(var(--primary));text-decoration:none;background:hsl(var(--secondary) / .35);}' +
    '.psr__all:hover{text-decoration:underline;}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function strip(s) { return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase() : s.toLowerCase(); }
  // Destaca o trecho digitado no nome (ignorando acento)
  function highlight(title, q) {
    var t = strip(title), k = strip(q).trim();
    var i = k ? t.indexOf(k) : -1;
    if (i < 0) return esc(title);
    return esc(title.slice(0, i)) + '<mark>' + esc(title.slice(i, i + k.length)) + '</mark>' + esc(title.slice(i + k.length));
  }
  function ensureHidden(form, name, value) {
    var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.insertBefore(el, form.firstChild);
    }
    el.value = value;
  }
  function priceOf(p) {
    var v = p.price_min != null ? p.price_min : p.price;
    var n = parseFloat(v);
    return isNaN(n) ? '' : fmt.format(n);
  }
  function imgOf(p) {
    var u = (p.featured_image && p.featured_image.url) || p.image || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function setup(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.dataset.psrReady) return;
    form.dataset.psrReady = '1';

    // Busca só produtos e aceita pedaço da última palavra
    ensureHidden(form, 'type', 'product');
    ensureHidden(form, 'options[prefix]', 'last');
    input.removeAttribute('required');
    input.setAttribute('autocomplete', 'off');

    // Busca vazia → todos os produtos
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) {
        e.preventDefault();
        window.location.href = '/collections/all';
      }
    });

    form.classList.add('psr-host');
    var box = document.createElement('div');
    box.className = 'psr';
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    form.appendChild(box);

    var timer = null, ctrl = null, active = -1, lastQ = '';

    function hide() { box.hidden = true; active = -1; }
    function items() { return box.querySelectorAll('.psr__item'); }
    function setActive(i) {
      var list = items();
      if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function (li, idx) { li.classList.toggle('is-active', idx === active); });
      list[active].scrollIntoView({ block: 'nearest' });
    }

    function render(q, products) {
      var allUrl = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
      if (!products.length) {
        box.innerHTML = '<div class="psr__empty">Nenhum produto encontrado para "<strong>' + esc(q) + '</strong>".</div>' +
          '<a class="psr__all" href="/collections/all">Ver todos os produtos →</a>';
      } else {
        box.innerHTML = '<ul class="psr__list">' + products.map(function (p) {
          var img = imgOf(p);
          return '<li class="psr__item" role="option"><a href="' + esc(p.url) + '">' +
            (img ? '<img class="psr__img" src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="psr__img"></span>') +
            '<span><span class="psr__title">' + highlight(p.title, q) + '</span>' +
            '<span class="psr__price">' + priceOf(p) + '</span></span></a></li>';
        }).join('') + '</ul>' +
        '<a class="psr__all" href="' + allUrl + '">Ver todos os resultados para "' + esc(q) + '" →</a>';
      }
      active = -1;
      box.hidden = false;
    }

    function search(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag,vendor';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return;
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          render(q, ps);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () { search(q); }, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false;
    });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { hide(); }
      else if (e.key === 'Enter' && active > -1) {
        var a = items()[active] && items()[active].querySelector('a');
        if (a) { e.preventDefault(); window.location.href = a.href; }
      }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });
  }

  function init() {
    document.querySelectorAll('form[action*="/search"]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
